import { type HTMLAttributes } from 'react'

import { cn } from './cn'

export type BadgeTone = 'accent' | 'neutral' | 'outline' | 'ok' | 'warn' | 'block'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
}

const TONE_CLASS: Record<BadgeTone, string> = {
  accent: 'tag-accent',
  neutral: 'tag-neutral',
  outline: 'tag-outline',
  ok: 'tag-ok',
  warn: 'tag-warn',
  block: 'tag-block',
}

/** `.tag` — the pill the mockup uses for roles, offices, flags and states. */
export function Badge({ tone = 'neutral', className, children, ...rest }: BadgeProps) {
  return (
    <span {...rest} className={cn('tag', TONE_CLASS[tone], className)}>
      {children}
    </span>
  )
}

/**
 * The gate chip that follows the workbench everywhere (plan §5 P5.4).
 *
 * It lives here rather than in the workbench because the header shows it too,
 * and because BLOCK must look the same in every place it can appear — a flag
 * that is red on one screen and grey on another is a flag nobody trusts.
 */
export function GateBadge({ blocks, warns }: { blocks: number; warns?: number }) {
  if (blocks > 0) {
    return (
      <Badge tone="block">
        {blocks} BLOCK {blocks === 1 ? 'open' : 'open'}
      </Badge>
    )
  }
  if (warns && warns > 0) {
    return <Badge tone="warn">{warns} WARN</Badge>
  }
  return <Badge tone="ok">gate clear</Badge>
}
